import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import { OrangeTextButton } from "../../common/OrangeTextButton";
import { Dispatcher } from "../Sites/SiteAboutPage/SiteAboutPageUtils/siteAboutInterfaces";

export const DiceTestFailDialog = ({
  diceTestFailDialogOpen,
  setDiceTestFailDialogOpen,
}: {
  diceTestFailDialogOpen: boolean;
  setDiceTestFailDialogOpen: Dispatcher<boolean>;
}) => {
  return (
    <Dialog open={diceTestFailDialogOpen}>
      <DialogContent>
        <p className="font-mulish text-[20px]">Dice test failed.</p>
        <br></br>
        <p>
          The test alert failed to reach your Dice server. Please ensure the
          information entered matches the generic stream device on your Dice
          Summary Report and that the site is armed in Dice. If you are still
          experiencing issues, please contact support@actuate.ai.{" "}
        </p>
      </DialogContent>
      <DialogActions>
        <OrangeTextButton
          onClick={() => {
            setDiceTestFailDialogOpen(false);
          }}
          text="Ok"
          disabled={false}
        />
      </DialogActions>
    </Dialog>
  );
};
